import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createAppKit } from '@reown/appkit/react';
// import { WagmiProvider } from 'wagmi';
import { App } from './App';
import { store } from '@/store';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { currentNetwork } from './utils/customNetwork';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { Toaster } from '@/components/common/Toaster';
import '@/utils/i18n';
import '@/styles/globals.css';

const queryClient = new QueryClient();

const projectId = import.meta.env.REACT_APP_PROJECT_ID || '';
const isTestnet = import.meta.env.REACT_APP_NETWORK === 'testnet';

const metadata = {
  name: isTestnet ? 'MST Testnet' : 'MST Mainnet',
  description: 'MST Blockchain...',
  url: isTestnet ? 'https://newsite.mstblockchain.com/' : 'https://mstblockchain.com/',
  icons: isTestnet
    ? ['https://staging.mstblockchain.com/images/logo/main.png']
    : ['https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/f6f79fda-3a73-4e9f-2e99-2d9ddc004100/sm'],
};
const wagmiAdapter = new WagmiAdapter({
  networks: [currentNetwork],
  projectId,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks: [currentNetwork],
  metadata,
  projectId,
  features: {
    analytics: true,
    socials: false,
    email: false,
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider>
            {/* <WagmiProvider config={wagmiAdapter.wagmiConfig}> */}
            {/* <QueryClientProvider client={queryClient}> */}
            <App />
            {/* </QueryClientProvider> */}
            {/* </WagmiProvider> */}
            <Toaster />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
